<div class="document-section">
  <div class="files-preview-container" *ngIf="files.length > 0">
    <div class="files-list">
      <div class="file-item" *ngFor="let file of files; let i = index">
        <div class="file-details">
          <div class="file-icon">

            <img *ngIf='fileType(file.name) == "doc"' src="./assets/images/file-icons/file-doc-icon.svg">

            <img *ngIf='fileType(file.name) == "jpg"' src="./assets/images/file-icons/file-jpg-icon.svg">

            <img *ngIf='fileType(file.name) == "pdf"' src="./assets/images/file-icons/file-pdf-icon.svg">

            <img *ngIf='fileType(file.name) == "png"' src="./assets/images/file-icons/file-png-icon.svg">

            <img *ngIf='fileType(file.name) == "xls"' src="./assets/images/file-icons/file-xls-icon.svg">

            <img *ngIf='fileType(file.name) == "zip"' src="./assets/images/file-icons/file-zip-icon.svg">

            <img *ngIf='fileType(file.name) == "ppt"' src="./assets/images/file-icons/file-ppt-icon.svg">

          </div>
          <div>
            <label [title]="file?.name">{{ file?.name }}</label>
            <div class="d-flex align-items-center">
              <span>{{ formatBytes(file?.size) }}</span>
              <b class="badge badge-danger ml-3" *ngIf='file.isDeleted'>({{'messages.Deleted' | translate}})</b>

              <ng-container *ngIf="file.canSignatureConfig">
                <a target="_blank" [routerLink]="['/admin/pdf', file.id, file.agendaItemId, meetingId]"
                  class="btn btn-primary btn-small ml-auto">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                    fill="#e8eaed">
                    <path
                      d="m234-480-12-60q-12-5-22.5-10.5T178-564l-58 18-40-68 46-40q-2-13-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T222-820l12-60h80l12 60q12 5 22.5 10.5T370-796l58-18 40 68-46 40q2 13 2 26t-2 26l46 40-40 68-58-18q-11 8-21.5 13.5T326-540l-12 60h-80Zm40-120q33 0 56.5-23.5T354-680q0-33-23.5-56.5T274-760q-33 0-56.5 23.5T194-680q0 33 23.5 56.5T274-600ZM592-40l-18-84q-17-6-31.5-14.5T514-158l-80 26-56-96 64-56q-2-18-2-36t2-36l-64-56 56-96 80 26q14-11 28.5-19.5T574-516l18-84h112l18 84q17 6 31.5 14.5T782-482l80-26 56 96-64 56q2 18 2 36t-2 36l64 56-56 96-80-26q-14 11-28.5 19.5T722-124l-18 84H592Zm56-160q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Z" />
                  </svg>
                  {{ 'users.Signature' | translate }}
                </a>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="file-btn" *ngIf='!file.isDeleted'>
          <!-- [href]="file.path" [download]="file.path" target="_blank" -->
          @if(canSaveFile){
          <a class="download" href="javascript:void(0)" (click)="download(file)">
            <svg width="16" height="16" viewBox="0 0 16 16">
              <path id="download-btn"
                d="M-168.666-163h-14.669a.667.667,0,0,1-.665-.669v-3.907a.668.668,0,0,1,.666-.67.669.669,0,0,1,.667.67v3.233h13.336v-3.233h0a.667.667,0,0,1,.665-.669h0a.667.667,0,0,1,.665.669h0v3.9a.667.667,0,0,1-.665.669Zm-7.823-4.45-3.831-4.143h0a.671.671,0,0,1-.178-.457.671.671,0,0,1,.668-.672.664.664,0,0,1,.49.215l2.675,2.895v-8.717A.669.669,0,0,1-176-179a.669.669,0,0,1,.667.671v8.711l2.674-2.893h0a.663.663,0,0,1,.49-.216.668.668,0,0,1,.667.67.67.67,0,0,1-.18.459l-3.83,4.148a.666.666,0,0,1-.488.213A.663.663,0,0,1-176.489-167.45Z"
                transform="translate(184 179)" fill="#F87F0F" />
            </svg>
          </a>
          }@else {
          <a class="download" appDownload [file]='file'>
            <svg width="16" height="16" viewBox="0 0 16 16">
              <path id="download-btn"
                d="M-168.666-163h-14.669a.667.667,0,0,1-.665-.669v-3.907a.668.668,0,0,1,.666-.67.669.669,0,0,1,.667.67v3.233h13.336v-3.233h0a.667.667,0,0,1,.665-.669h0a.667.667,0,0,1,.665.669h0v3.9a.667.667,0,0,1-.665.669Zm-7.823-4.45-3.831-4.143h0a.671.671,0,0,1-.178-.457.671.671,0,0,1,.668-.672.664.664,0,0,1,.49.215l2.675,2.895v-8.717A.669.669,0,0,1-176-179a.669.669,0,0,1,.667.671v8.711l2.674-2.893h0a.663.663,0,0,1,.49-.216.668.668,0,0,1,.667.67.67.67,0,0,1-.18.459l-3.83,4.148a.666.666,0,0,1-.488.213A.663.663,0,0,1-176.489-167.45Z"
                transform="translate(184 179)" fill="#F87F0F" />
            </svg>
          </a>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="no-document" *ngIf="files.length == 0">
    <img src="./assets/images/no-attachments-illustration.png" alt="logo" />
    <p>{{ 'group.NoFiles' | translate }}</p>
  </div>
</div>
